import useLocalStorage from "./useLocalStorage"

export default function useSidebarHidden() {
  return useLocalStorage<boolean>("sidebarHidden", false)
}
